import React, { useImperativeHandle } from 'react';
import isEmpty from 'lodash/isEmpty';
import { i18n } from 'fishx';

import { Form } from '@whalecloud/fdx';
import { DeviceFormItem } from '@/components';

const SharedDeviceAttr = props => {
  const { modelKey, refInstance, form } = props;
  const { validateFields, getFieldsValue } = form;

  useImperativeHandle(refInstance, () => ({
    getSharedDeviceAttributeInfo: async() => {
      await validateFields();
      const formInfo = getFieldsValue();
      const attrList = [];
      (Object.keys(formInfo) || []).forEach(key => {
        if (!key.includes('empty') && !isEmpty(formInfo[key])) {
          attrList.push({
            attrCode: key,
            attrValue: formInfo[key],
            value: formInfo[key],
          });
        }
      });
      return attrList;
    },
  }));

  return (
    <Form layout="inline">
      <div className="blockWrap">
        <h3 className="blockTitle">{i18n('SHARED_DEVICE')}</h3>
        <div className="formItemBox">
          <DeviceFormItem modelKey={modelKey} form={form} />
        </div>
      </div>
    </Form>
  );
};

const Component = Form.create({ name: 'attribute.sharedDeviceAttr' })(SharedDeviceAttr);
export default React.forwardRef((props, ref) => <Component {...props} refInstance={ref} />);
